import React, { useState } from 'react';
import '../../css/Login.css';
import logo from '../../assets/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

function Register() {
    const navigate = useNavigate();

    // Account Information
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [phone, setPhone] = useState('');

    // Personal Information
    const [gender, setGender] = useState('');

    // Address Information
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [country, setCountry] = useState('');

    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleRegister = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        setIsLoading(true);

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            await setDoc(doc(db, 'users', user.uid), {
                uid: user.uid,
                firstName,
                lastName,
                email,
                phone,
                password,
                gender: gender || null,
                address1,
                address2: address2 || '',
                city,
                state,
                postalCode,
                country,
                createdAt: new Date().toISOString()
            });

            navigate('/');
        } catch (err) {
            console.error(err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src={logo} alt="Logo" className="login-logo" />
                <h2 className="login-title">Create Account</h2>
                <p className="login-subtitle">Register to start shopping with us</p>

                <form className="login-form" onSubmit={handleRegister}>

                    {/* Account Information */}
                    <input className='login-input' type="text" placeholder="First Name" value={firstName}
                        onChange={(e) => setFirstName(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="text" placeholder="Last Name" value={lastName}
                        onChange={(e) => setLastName(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="email" placeholder="Email Address" value={email}
                        onChange={(e) => setEmail(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="password" placeholder="Password" value={password}
                        onChange={(e) => setPassword(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="password" placeholder="Confirm Password" value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="tel" placeholder="Phone Number" value={phone}
                        onChange={(e) => setPhone(e.target.value)} required disabled={isLoading} />

                    {/* Personal Information */}
                    <select value={gender} onChange={(e) => setGender(e.target.value)} disabled={isLoading}>
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                    </select>

                    {/* Address Information */}
                    <input className='login-input' type="text" placeholder="Address Line 1" value={address1}
                        onChange={(e) => setAddress1(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="text" placeholder="Address Line 2" value={address2}
                        onChange={(e) => setAddress2(e.target.value)} disabled={isLoading} />
                    <input className='login-input' type="text" placeholder="City" value={city}
                        onChange={(e) => setCity(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="text" placeholder="State / Province / Region" value={state}
                        onChange={(e) => setState(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="text" placeholder="Postal / ZIP Code" value={postalCode}
                        onChange={(e) => setPostalCode(e.target.value)} required disabled={isLoading} />
                    <input className='login-input' type="text" placeholder="Country" value={country}
                        onChange={(e) => setCountry(e.target.value)} required disabled={isLoading} />

                    {error && <p className="error-message">{error}</p>}

                    <button type="submit" className="login-button" disabled={isLoading}>
                        {isLoading ? <div className="spinner"></div> : 'Register'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>
                        Already have an account?{' '}
                        <Link to="/login" className="login-link">Login</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Register;
